import ArticleViewService from "@core-ui/ContextServices/views/articleView/ArticleViewService";
import { ArticlePageData } from "@core/SitePresenter/SitePresenter";

const ArticleViewContainer = ({ data }: { data: ArticlePageData }) => {
	const ArticleView = ArticleViewService.value;

	return (
		<div style={{ height: "inherit" }}>
			<ArticleView data={data} />
		</div>
	);
};

export default ArticleViewContainer;
